import React, { createContext, useContext, useMemo, useState } from 'react'

const FiltersContext = createContext(null)

export const FiltersProvider = ({ children }) => {
  const [selectedPrimary, setSelectedPrimary] = useState(['All'])
  const [filterOptions, setFilterOptions] = useState({ label: 'Filter', options: [] })

  const value = useMemo(() => ({
    selectedPrimary,
    setSelectedPrimary,
    filterOptions,
    setFilterOptions,
  }), [selectedPrimary, filterOptions])

  return (
    <FiltersContext.Provider value={value}>
      {children}
    </FiltersContext.Provider>
  )
}

export const useFilters = () => {
  const ctx = useContext(FiltersContext)
  if (!ctx) throw new Error('useFilters must be used within FiltersProvider')
  return ctx
} 